import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export const RestrictedRoute = ({
  component: Component,
  redirectTo = '/admin/dashboard',
}) => {
  const isLoggedIn = useSelector(state => state.admin?.isLoggedIn);

  if (isLoggedIn) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Component />;
};

